export enum FormEnum {
  name = 'name',
  description = 'description',
  image = 'image',
  displays = 'displays',
  contract = 'contract',
  branch = 'branch',
  active = 'active',
  view = 'view',
  created_by = 'created_by',
  client = 'client',
  branches = 'branches',
  start_date = 'start_date',
  end_date = 'end_date',
  createdAt = 'createdAt',
  updatedAt = 'updatedAt',
  display_type = 'display_type',
  display_servicios = 'display_servicios',
  phone = 'phone',
  address = 'address',
  website = 'website',
  user_type = 'user_type',
  id = '_id',
  username = 'username',
  email = 'email',
  role = 'role',
  roles = 'roles',
  token = 'token',
  password = 'password',
  confirmPassword = 'confirmPassword',
  text = 'text',
}
